/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUpdateHistoryEvent
 */
export interface InputUpdateHistoryEvent {
    /**
     * 
     * @type {string}
     * @memberof InputUpdateHistoryEvent
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUpdateHistoryEvent
     */
    eventTime: string;
    /**
     * 
     * @type {number}
     * @memberof InputUpdateHistoryEvent
     */
    teamId?: number;
    /**
     * 
     * @type {string}
     * @memberof InputUpdateHistoryEvent
     */
    video?: string;
    /**
     * 
     * @type {number}
     * @memberof InputUpdateHistoryEvent
     */
    zoneId?: number;
}

/**
 * Check if a given object implements the InputUpdateHistoryEvent interface.
 */
export function instanceOfInputUpdateHistoryEvent(value: object): boolean {
    if (!('eventTime' in value)) return false;
    return true;
}

export function InputUpdateHistoryEventFromJSON(json: any): InputUpdateHistoryEvent {
    return InputUpdateHistoryEventFromJSONTyped(json, false);
}

export function InputUpdateHistoryEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUpdateHistoryEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'eventTime': json['eventTime'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'video': json['video'] == null ? undefined : json['video'],
        'zoneId': json['zoneId'] == null ? undefined : json['zoneId'],
    };
}

export function InputUpdateHistoryEventToJSON(value?: InputUpdateHistoryEvent | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'eventTime': value['eventTime'],
        'teamId': value['teamId'],
        'video': value['video'],
        'zoneId': value['zoneId'],
    };
}

